import {
  GetCostsQueryResponseType,
  IGetCostsQueryParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCosts/getCostsQuery.type';
import { getCostsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCosts/getCostsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getShowCostsQueryOptions = (params: IGetCostsQueryParams) => {
  return queryOptions({
    queryKey: ['costs', params],
    queryFn: () => getCostsFunction(params),
    select: (data: GetCostsQueryResponseType) => {
      return {
        totalPrice: data?.parts_damage_total,
        showCosts: [
          {
            label: 'هزینه حمل و نقل :',
            value: data?.parts_transportation
              ? `${data?.parts_transportation?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
          {
            label: 'ارزش قطعات داغی :',
            value: data?.parts_daghi
              ? `${data?.parts_daghi?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
          {
            label: 'کسورات :',
            value: data?.parts_reduction
              ? `${data?.parts_reduction?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
          {
            label: 'ارزش روز وسیله‌نقلیه :',
            value: data?.vehicle_price
              ? `${data?.vehicle_price?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
          {
            label: 'هزینه لوازم تعویضی :',
            value: data?.parts_cost
              ? `${data?.parts_cost?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
          {
            label: 'هزینه اجرت تعمیرات : ',
            value: data?.parts_payment
              ? `${data?.parts_payment?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
          {
            label: 'بالاترین ارزش لاشه :',
            value: data?.parts_max_body_price
              ? `${data?.parts_max_body_price?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
          {
            label: 'کسورات بازدید سلامت قبلی :',
            value: data?.parts_prev_reduction
              ? `${data?.parts_prev_reduction?.toLocaleString('fa')} ریال`
              : 'مشخص نیست',
          },
        ],
      };
    },
  });
};
